import React, { useEffect, useState, useReducer } from "react";
import { FilterVacancyCompany } from "../../components/filter/filter-vacancy-company";
import ManageTable from "../../components/manageTable/ManageTable";
import { useLocation } from "react-router-dom";
import { useStores } from "../../stores";
import { useTranslation } from "react-i18next";
import applicationService from "../../api/application.api";
import vacansyService from "../../api/vacancy.api";
import TemplateAction from "./actions/template-action";

const TEMPLATE_TYPE = [
    { name: "Вакансии", type: "vacancy" },
    { name: "Заявки", type: "application" },
];


type State = {
    vacancyCompanyId: number | null;
    type: string;
};

type ListState = {
    vacancy: any[];
    application: any[];
};

const reducer = (state: State, action: Partial<State>) => ({
    ...state,
    ...action,
});

const TemplateController = () => {
    const [formValues, setFormValues] = useReducer(reducer, {
        vacancyCompanyId: null,
        type: "",
    });

    const [list, setList] = useState<ListState>({
        vacancy: [],
        application: [],
    });

    const { routerStore } = useStores();
    const location = useLocation();
    const { t } = useTranslation();

    // Устанавливаем текущий путь в store
    useEffect(() => {
        routerStore.setCurrentPath(location.pathname);
    }, [location.pathname]);

    const {authStore} = useStores()
    // Универсальная функция загрузки данных
    const fetchTemplates = async (type: string, vacancyCompanyId?: number | null) => {
        if (!type) return;

        const service = type === "vacancy" ? vacansyService : applicationService;
        const vacancyCompany = vacancyCompanyId || authStore.user?.vacancyCompany || null
        const { data } = await service.findAllTemplates(vacancyCompany || null);

        setList(prev => ({ ...prev, [type]: data }));
    };

    // Обновление списка при изменении фильтров
    useEffect(() => {
        if (formValues.type) {
            fetchTemplates(formValues.type, formValues.vacancyCompanyId);
        }
    }, [formValues]);

    return (
        <div>
            <h3>Управление шаблонами</h3>

            <div>
                <div className="mb-4 flex gap-4 mt-4 w-1/2">
                    <FilterVacancyCompany
                        selectedValue={formValues.vacancyCompanyId}
                        onValueChange={(name, value) => setFormValues({ [name]: +value })}
                        fieldName="vacancyCompanyId"
                        className="flex flex-col w-1/2"
                    />
                    <div className="w-1/2 h-full">
                        <label className="mb-2">Тип шаблона</label>
                        <select
                            className="form-select h-[41px]"
                            id="groupSelect"
                            value={formValues.type}
                            name="type"
                            required
                            onChange={(e) => setFormValues({ type: e.target.value })}
                            aria-label="group label select example"
                        >
                            <option value="">-Тип шаблона-</option>
                            {TEMPLATE_TYPE.map((type) => (
                                <option key={type.type} value={type.type}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {formValues.type && (
                    <ManageTable
                        header={<></>}
                        pages={[]}
                        title={TEMPLATE_TYPE.find((item) => item.type === formValues.type)?.name || "Шаблоны"}
                        footer={<></>}
                    >
                        <thead>
                        <tr>
                            <th style={{ cursor: "pointer" }}>ID</th>
                            <th style={{ cursor: "pointer" }}>Название</th>
                            <th className="flex justify-end mr-2">{t("vacancy.operations")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {list[formValues.type as keyof typeof list].length > 0 ? (
                            list[formValues.type as keyof typeof list].map((item: any) => (
                                <tr key={item.id}>
                                    <td className="pt-3">{item.id}</td>
                                    <td className="pt-3 [w-1/2]">{item.position}</td>
                                    <td className="flex justify-end mr-5">
                                        <TemplateAction update={() => fetchTemplates(formValues.type, formValues.vacancyCompanyId)} item={item} type={formValues.type} />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={5} className="text-center p-5">
                                    Шаблоны не найдены
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </ManageTable>
                )}
            </div>
        </div>
    );
};

export default TemplateController;
